<template lang="pug">
form(@submit.prevent="onSubmit")
  .form-group(v-if="Object.keys(errors).length")
    .alert.error_explanation
      form-error(:errors="errors")

  div
    .grid.grid-cols-1.gap-8.mx-auto.mt-12(class="lg:grid-cols-2 lg:gap-12")
      .form-group
        label(class="block font-medium mb-3")
          span Prénom*
        input#contact_firstname.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.firstname" type="text" required="required" placeholder="Votre prénom" :class="{'field_with_errors': errors.firstname}")

      .form-group
        label(class="block font-medium mb-3")
          span Nom*
        input#contact_lastname.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.lastname" type="text" required="required" placeholder="Votre nom" :class="{'field_with_errors': errors.lastname}")

    .grid.grid-cols-1.gap-8.mx-auto.mt-12(class="lg:grid-cols-2 lg:gap-12")
      .form-group
        label(class="block font-medium mb-3")
          span Email*
        input#contact_email.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.email" type="email" required="required" placeholder="Votre e-mail" :class="{'field_with_errors': errors.base}")

      .form-group
        label(class="block font-medium mb-3")
          span Téléphone*
        input#contact_phone.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.phone" type="phone" required="required" placeholder="Votre numéro de tél." :class="{'field_with_errors': errors.base}")

    .grid.grid-cols-1.gap-8.mx-auto.mt-12(class="lg:grid-cols-2 lg:gap-12")
      .form-group
        label(class="block font-medium mb-3")
          span Entreprise
        input#contact_company.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.company" type="text" placeholder="Votre entreprise" :class="{'field_with_errors': errors.base}")

      .form-group(v-if="shouldShowRoleField === true")
        label(class="block font-medium mb-3")
          span Votre poste actuel*

        input#contact_role.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full(v-model="contact.role" type="text" required="required" placeholder="Votre intitulé de poste" :class="{'field_with_errors': errors.base}")

    .flex
      div
        label(class="block font-medium")
          p Nombre de place(s)
          p.text-12 Limité à 2 par personne
      .ml-10
        .relative
          i.fal.fa-chevron-down.absolute.top-0.right-0.text-12.pr-5.pt-5
          select#contact_entree.bg-white.rounded-md.px-6.py-3.text-tertiary.font-medium.w-full.w-130.appearance-none(v-model="contact.entree" type="integer" :class="{'field_with_errors': errors.base}")
            option 1
            option 2

    .mt-8(class="xl:flex")
      div
        label(class="checkbox-native inline-block font-sans relative pl-10 mr-12 text-xs font-light text-gray-800 cursor-pointer select-none")
          span En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter. Découvrez comment nous recueillons et utilisons vos données en lisant notre Politique d’utilisation des données.
          input(class="checkbox-native__input absolute opacity-0 cursor-pointer h-0 w-0" type="checkbox" name="rgpd_terms_accepted" value="true" v-model="contact.rgpd_terms_accepted")
          span(class="checkbox-native__checkmark absolute top-2 transform left-0 w-6 h-6 border border-black rounded-sm")

    .mt-12.text-center(class="xl:mt-0 xl:ml-12 xl:text-center")
      vue-recaptcha(
        ref="recaptcha"
        size="invisible"
        :sitekey="recaptchaAppKey"
        @verify="onCaptchaVerify"
        @expired="onCaptchaExpired"
      )

      input(type="submit" :id="submitButtonId" :disabled="!canSubmit" value="Je m'inscris" class="bg-tertiary text-white flex-shrink-0 mt-10  btn btn-rounded btn-arrow duration-150 px-6")
  </template>

<script>
import axios from 'axios'
import { VueRecaptcha } from 'vue-recaptcha'
import FormError from '@components/FormError'

export default {
  components: {
    VueRecaptcha,
    FormError
  },

  props: {
    recaptchaAppKey: {
      type: String,
      required: true
    },

    redirectOnSubmit: {
      type: String,
      default: '/contacts'
    },

    contactable: {
      type: Object,
      default () { return {} }
    },

    subject: {
      type: String,
      required: true
    },

    showRoleField: {
      type: Boolean
    },

    submitButtonId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      shouldShowRoleField: this.showRoleField,

      contact: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        company: '',
        role: '',
        entree: "1",
        message: 'evenement',
        subject: this.subject,
        contactable_type: this.contactable.contactable_type,
        contactable_id: this.contactable.contactable_id,
        rgpd_terms_accepted: this.rgpd_terms_accepted,
        url: window.location.href
      },
      errors: [],
      isSubmitting: false
    }
  },

  computed: {
    canSubmit () {
      return !!(
        this.contact.firstname &&
        this.contact.lastname &&
        this.contact.phone &&
        this.contact.email
      )
    }
  },

  methods: {
    onSubmit () {
      this.$refs.recaptcha.execute()
    },

    onCaptchaVerify (recaptchaToken) {
      this.isSubmitting = true
      this.$refs.recaptcha.reset()

      this.errors = []

      axios.post('/api/v1/contacts', {
        contact: this.contact,
        'g-recaptcha-response': recaptchaToken
      })
        .then(() => {
          window.location.href = this.redirectOnSubmit
        })
        .catch(({ response: { data } }) => {
          this.isSubmitting = false
          this.errors = data.errors.data.attributes.errors
        })
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style lang="css">
.w-130 {
  min-width: 130px;
}
</style>
